<div class="p-3">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h5 class="mb-0">
      <ng-container *ngIf="!txnData.isUpdate"> Add New </ng-container>
      <ng-container *ngIf="txnData.isUpdate"> Edit </ng-container>
      {{ txnData.column | column }}
    </h5>
    <img
      src="assets/images/close-icon.svg"
      alt="close-icon"
      class="cursor-pointer"
      [attr.aria-hidden]="true"
      (click)="closeDialogRef.close(false)" />
  </div>

  <form
    class="mat-form"
    [formGroup]="upsertTransactionSettingFrom"
    (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-12 form-group">
        <app-input-select
          (selectionChange)="onSourceCountryChange($event)"
          [inputData]="attrConstant.srcCountry"
          [selectOptions]="txnData.sourceCountryList"
          [bindLabel]="'countryName'"
          [bindValue]="'countryCode'"
          [formControlName]="attrConstant.srcCountry.key"></app-input-select>
      </div>
      <div class="col-md-12 form-group">
        <app-input-select
          [inputData]="attrConstant.destCountry"
          [selectOptions]="destCountryList"
          [bindLabel]="'countryName'"
          [bindValue]="'countryCode'"
          [formControlName]="attrConstant.destCountry.key"></app-input-select>
      </div>
      <div class="col-md-12 form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{ txnData.column | column }}</mat-label>
          <mat-select formControlName="name">
            <mat-option value="">
              Select {{ txnData.column | column }}
            </mat-option>
            <mat-option *ngFor="let data of txnSettings" [value]="data.code">
              {{ data.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row mt-3 justify-content-end">
      <div class="col-md-6">
        <button
          class="btn primary-btn w-100"
          [ngClass]="isSubmitLoading ? 'dsbld' : 'enbld'">
          <img
            *ngIf="isSubmitLoading"
            src="assets/images/button-spinner.svg"
            alt="button-spinner" />{{ txnData.isUpdate ? 'Update' : 'Add' }}
        </button>
      </div>
    </div>
  </form>
</div>
